import { Box, CardContent, CardHeader, IconButton, Tooltip } from "@mui/material";
import { connect } from "react-redux";
import { useState, useEffect, useContext } from "react";
import { IComment } from "./CommentContainer";
import EditableComment from "./EditableComment";
import { Done } from "@mui/icons-material";
import CommentDeleteDialog from "./CommentDeleteDialog";
import EditCommentMenu from "./EditCommentMenu";
import { selectUserId } from "../../redux/selectors/editor";
import { FirebaseContext } from "../firebase/FirebaseProvider";
import UserAvatar from "../navbar/UserAvatar";
import Timestamp from "../../utility/Timestamp";

interface CommentProps
{
    details: IComment;
    updateComment: (comment: string) => void;
    deleteComment: () => void;
    userId: string | null;
    deleteText: string;
    markAsResolved?: () => void;
}

function Comment({ userId, details, deleteText, updateComment, deleteComment, markAsResolved }: CommentProps)
{
    const [username, setUsername] = useState<string>("");
    const [editMode, setEditMode] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState(false);

    const { get } = useContext(FirebaseContext);

    useEffect(() =>
    {
        let isLoaded = true;
        if (username.length === 0)
        {
            get(`users/${details.userId}/name`)
                .then((name) =>
                {
                    if (typeof name === "string" && isLoaded)
                        setUsername(name);
                });
        }

        return () =>
        {
            isLoaded = false;
        }
    }, [details.userId, username, get])

    const onClickEdit = () =>
    {
        setEditMode(true);
    }

    const onClickDelete = () =>
    {
        setDeleteConfirm(true);
    }

    const handleOnClickConfirmDelete = () =>
    {
        deleteComment();
        setDeleteConfirm(false);
    }

    const handleOnClickCancel = () => { setDeleteConfirm(false); }

    return (
        <Box>
            <CardHeader style={{ padding: "6px" }}
                avatar={
                    <UserAvatar user={{ name: username }} />
                }
                action={<Box sx={{ display: 'flex' }}>
                    {markAsResolved && <Box><Tooltip title="Mark as resolved and hide discussion">
                        <IconButton color={"primary"} onClick={markAsResolved} size="large">
                            <Done />
                        </IconButton>
                    </Tooltip>
                    </Box>}
                    {userId === details.userId &&
                        <EditCommentMenu options={{
                            "Edit": onClickEdit,
                            "Delete": onClickDelete
                        }} />
                    }
                </Box>
                }
                title={username}
                subheader={<Timestamp value={details.timestamp} />}
            />
            < CardContent style={{ padding: "0px 8px 4px 8px" }}>
                <EditableComment updateComment={updateComment} editMode={editMode} setEditMode={setEditMode} commentText={details.comment} />
            </CardContent >
            <CommentDeleteDialog open={deleteConfirm}
                title="Confirm Delete"
                text={deleteText}
                onDeleteConfirmed={handleOnClickConfirmDelete}
                onDeleteCanceled={handleOnClickCancel} />
        </Box >
    );
}

const mapStateToProps = (store: never) => ({
    userId: selectUserId(store),
});

export default connect(mapStateToProps, {
})(Comment);

